import React from 'react'

function Refund() {
  return (
    <div className='paymentCard'>
    <img style={{ margin: '0' }} src="logo-pych.png" alt="logo-pych" />
    <h3> הכרטיס זוכה בהצלחה</h3>
    <p>צוות פאייכלה</p>
   </div>
  )
}

export default Refund